/*
takes a string (as sentence) containing a {linkTitle}
further values are linkTitle (actual title string) and an href
determines where to add the <a> tag and replaces the {linkTitle} variable with the actual title
*/

import {getLocale} from '@epic-core/common';
import React from 'react';

import {CmsLinkParagraph} from '../types';

interface Props {
  linkDetails: CmsLinkParagraph;
}

const LinkParagraph = ({linkDetails}: Props) => {
  const {linkTitle = '', linkParagraph = ''} = linkDetails;
  let {linkHref = ''} = linkDetails;
  const reg = new RegExp('(' + '{linkTitle}' + ')', 'gi');
  const paragraphGroups = linkParagraph.split(reg);

  if (linkHref.includes('{locale}')) {
    // eslint-disable-next-line no-param-reassign
    linkHref = linkHref.replace('{locale}', getLocale());
  }

  return paragraphGroups.length > 0 ? (
    <>
      {paragraphGroups.map((str, i) => {
        const isLinkTitle = str === '{linkTitle}';

        if (isLinkTitle) {
          return (
            <a target="_blank" href={linkHref} rel="noreferrer">
              {linkTitle}
            </a>
          );
        } else {
          return str;
        }
      })}
    </>
  ) : (
    <> </>
  );
};

export default LinkParagraph;
